export var MuiButtonBase = {};
//# sourceMappingURL=MuiButtonBase.js.map